import { LoginResponseInterface } from '../../models/login-response.interface';

export interface RefreshTokenState {
  customerToken: LoginResponseInterface;
}

export const initialRefreshTokenState: RefreshTokenState = {
  customerToken: null
};
